import React from 'react';
import { motion } from 'framer-motion';
import { X, Check, ShieldCheck, Clock, CreditCard, Banknote } from 'lucide-react';
const finalComparison = [{
  sin: 'Perfiles quemados',
  con: 'Cortes exactos desde el primer día'
}, {
  sin: 'Presupuestos 3 horas a mano',
  con: '15 minutos con sistema probado'
}, {
  sin: 'Clientes que no responden',
  con: 'Scripts listos para cerrar'
}, {
  sin: 'No sabés si ganás o perdés',
  con: 'Tracker que te dice el margen real'
}];
export function ClosingSection() {
  return <section className="py-10 bg-white" data-id="element-29">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-30">
        <div className="text-center mb-8" data-id="element-31">
          <h2 className="text-xl md:text-3xl font-black text-matte mb-1" data-id="element-32">
            La pregunta no es si hay trabajo de carpintería en Argentina.
          </h2>
          <h3 className="text-xl md:text-2xl font-black text-steel mb-3" data-id="element-33">
            Siempre hay.
          </h3>
          <p className="text-lg text-gray-600 font-medium mb-1" data-id="element-34">
            La pregunta es:
          </p>
          <h2 className="text-2xl md:text-4xl font-black text-matte" data-id="element-35">
            ¿Vas a estar preparado cuando llegue?
          </h2>
          <div className="w-16 h-1 bg-gold mx-auto mt-4" data-id="element-36"></div>
        </div>

        <div className="grid md:grid-cols-2 gap-0 border border-gray-200 mb-10 shadow-md overflow-hidden" data-id="element-37">
          <div className="bg-gray-50 p-5 md:p-6 border-b md:border-b-0 md:border-r border-gray-200" data-id="element-38">
            <h3 className="text-sm font-bold text-red-600 mb-4 flex items-center justify-center uppercase tracking-wider" data-id="element-39">
              <X className="w-4 h-4 mr-1.5" data-id="element-40" /> Sin el sistema
            </h3>
            <ul className="space-y-3" data-id="element-41">
              {finalComparison.map((row, i) => <li key={i} className="flex items-start text-gray-600 text-sm" data-id="element-42">
                  <X className="w-4 h-4 text-red-400 mr-2 flex-shrink-0 mt-0.5" data-id="element-43" />
                  <span data-id="element-44">{row.sin}</span>
                </li>)}
            </ul>
          </div>
          <div className="bg-steel p-5 md:p-6 text-white" data-id="element-45">
            <h3 className="text-sm font-bold text-gold mb-4 flex items-center justify-center uppercase tracking-wider" data-id="element-46">
              <Check className="w-4 h-4 mr-1.5" data-id="element-47" /> Con el sistema
            </h3>
            <ul className="space-y-3" data-id="element-48">
              {finalComparison.map((row, i) => <li key={i} className="flex items-start text-silver text-sm" data-id="element-49">
                  <Check className="w-4 h-4 text-gold mr-2 flex-shrink-0 mt-0.5" data-id="element-50" />
                  <span data-id="element-51">{row.con}</span>
                </li>)}
            </ul>
          </div>
        </div>

        <div className="flex flex-col md:flex-row gap-4 justify-center items-center mb-8" data-id="element-52">
          <a href="https://solucionstore.shop/cart/45494138568895:1" target="_blank" rel="noopener noreferrer" className="w-full md:w-auto bg-steel text-white font-bold text-base px-6 py-3.5 text-center hover:bg-steel/90 transition-colors uppercase" data-id="element-53">
            Super Combo por $19.990 →
          </a>
          <a href="https://solucionstore.shop/cart/45494160785599:1" target="_blank" rel="noopener noreferrer" className="w-full md:w-auto bg-gold text-matte font-black text-lg px-6 py-4 text-center shadow-[0_0_20px_rgba(212,160,23,0.4)] hover:shadow-[0_0_30px_rgba(212,160,23,0.6)] transition-all uppercase" data-id="element-54">
            Combo Completo por $27.990 →
          </a>
        </div>

        <div className="flex flex-wrap justify-center gap-3 text-xs text-gray-500 font-medium pb-6 border-b border-gray-200" data-id="element-55">
          <span className="flex items-center" data-id="element-56">
            <ShieldCheck className="w-3.5 h-3.5 mr-1" data-id="element-57" /> Pago seguro
          </span>
          <span className="flex items-center" data-id="element-58">
            <Clock className="w-3.5 h-3.5 mr-1" data-id="element-59" /> Acceso en 5 min
          </span>
          <span className="flex items-center" data-id="element-60">
            <ShieldCheck className="w-3.5 h-3.5 mr-1" data-id="element-61" /> Garantía 7 días
          </span>
          <span className="flex items-center" data-id="element-62">
            <CreditCard className="w-3.5 h-3.5 mr-1" data-id="element-63" /> Mercado Pago
          </span>
          <span className="flex items-center" data-id="element-64">
            <CreditCard className="w-3.5 h-3.5 mr-1" data-id="element-65" /> Tarjeta
          </span>
          <span className="flex items-center" data-id="element-66">
            <Banknote className="w-3.5 h-3.5 mr-1" data-id="element-67" /> Transferencia
          </span>
        </div>

        <div className="text-center text-xs text-gray-400 mt-6" data-id="element-68">
          © Super Combo Carpintería en Aluminio PRO 2026 — Argentina
        </div>
      </div>
    </section>;
}